<template>
  <div>
    <Dialog v-model="isShowDir" title="选择源数据路径" size="small">
      <Form v-if="isShowDir" style="width:100%;">
        <FormItem label="源数据路径">
          <div>
            <PathSelect
              @path-selected="selectBucketPath"
              :tree="bucketPathList"
              :loading="pathLoading"
            ></PathSelect>
          </div>
        </FormItem>
      </Form>
    </Dialog>

    <div
      class="c-mgb-20"
      v-if="
        dbtype.type === 'ks3' &&
          action !== 'create' &&
          dbtype.db !== 'sample_database'
      "
    >
      <Button
        :type="action === 'edit' ? 'primary' : 'secondary'"
        class="c-mgr-20"
        @click="edit"
        >编辑数据表</Button
      >
      <Button
        class="c-mgr-20"
        :type="isCreate ? 'primary' : 'secondary'"
        @click="create"
        >创建数据表</Button
      >
      <Button v-if="action !== 'create'" type="secondary" @click="del"
        >删除数据表</Button
      >
      <!-- <Button v-if="action !== 'create'" type="secondary" @click="query"
        >查看数据</Button
      > -->
    </div>
    <div style="background:#eee;height:1px;width:100%;"></div>
    <div style="overflow: auto;" :style="{ height: formBoxHeight + 'px' }">
      <Form
        layout="horizontal"
        labelWidth="140"
        class="line-dep-top"
        model="tableDetail"
      >
        <FormItem
          class="option-item-name"
          label="表名称"
          model="tableDetail.TableName"
          :rules="{
            maxLength: 45,
            namerule: true,
            required: true
          }"
        >
          <Input v-if="isCreate" v-model="tableDetail.TableName" />
          <span v-if="action === 'read' || action === 'edit'">{{
            tableDetail.TableName
          }}</span>
        </FormItem>
        <template v-if="dbtype.type === 'ks3'">
          <!-- 编辑和查看时，直接显示拼好的路径 -->
          <FormItem
            label="数据存储位置"
            model="tableDetail.Location"
            v-if="action === 'read' || action === 'edit'"
          >
            <span>{{ tableDetail.Location }} </span>
            <!-- <Input v-model="tableDetail.Location"  /> -->
          </FormItem>
          <!-- 创建，选择bucket和填写源数据路径 -->
          <FormItem
            label="bucket"
            v-if="isCreate"
            model="tableDetail.Bucket"
            :rules="{
              required: true
            }"
          >
            <div style="width:100%">
              <Select
                filterable
                v-model="tableDetail.Bucket"
                :value="tableDetail.Bucket"
              >
                <Option v-for="type in bucketList" :key="type" :value="type">
                  {{ type }}
                </Option>
              </Select>
            </div>
          </FormItem>
          <FormItem label="分区表" v-if="isCreate">
            <div class="k-wrapper k-text" style="width:100%">
              <Radio
                name="radio"
                trueValue="1"
                v-model="tableDetail.IsPartition"
                >是</Radio
              >
              <Radio
                name="radio"
                trueValue="0"
                v-model="tableDetail.IsPartition"
                >否</Radio
              >
            </div>
            <template slot="append">
              <Tooltip theme="light" canHover content="目前仅支持日期分区">
                <Icon class="ion-ios-help-outline"></Icon>
              </Tooltip>
            </template>
          </FormItem>
          <FormItem
            label="源数据路径"
            v-if="isCreate"
            model="tableDetail.Path"
            :rules="{
              required: !tableDetail.IsPartition
            }"
          >
            <div style="width:100%">
              <Select
                filterable
                allowUnmatch
                v-model="tableDetail.Path"
                :value="tableDetail.Path"
                :loading="pathLoading"
                :position="{ my: 'left top+8', at: 'left bottom' }"
              >
                <Option
                  v-for="type in bucketPathList"
                  :key="type"
                  :value="type"
                >
                  {{ type }}
                </Option>
              </Select>
            </div>
            <template slot="append">
              <div style="cursor:pointer;display:inline-block" @click="showDir">
                <i
                  class="icon ion-ios-folder-outline"
                  style="vertical-align: text-bottom;"
                ></i>
              </div>
              <div
                style="cursor:pointer;display:inline-block;padding-left:0.625rem"
                @click="getBucketPath"
              >
                <i
                  class="icon ion-ios-refresh-outline"
                  style="vertical-align: text-bottom;"
                ></i>
              </div>
              <div
                style="cursor:pointer;display:inline-block;padding-left:0.625rem"
              >
                <Tooltip
                  theme="light"
                  canHover
                  content="若您填写路径为新路径，将自动在KS3创建该路径；默认加载目录下全部文件到表，以第一个文件格式为准，不支持加载指定文件到表"
                >
                  <i
                    class="icon ion-ios-help-outline"
                    style="vertical-align: text-bottom;"
                  ></i>
                </Tooltip>
              </div>
            </template>
          </FormItem>
          <FormItem
            v-if="showPartition && isCreate"
            class="option-item-name"
            label="分区分隔符"
            :rules="{
              maxLength: 45
            }"
          >
            <Input v-model="tableDetail.PartitionSeparation" />
            <template slot="append">
              <Tooltip
                theme="light"
                canHover
                content="指路径中的分隔符，分隔符后面值为分区值，如：ks3://qe.ks3-gz.ksyun.com/d=202004/此处分隔符为 '='，分区值为 '202004'"
              >
                <Icon class="ion-ios-help-outline"></Icon>
              </Tooltip>
            </template>
          </FormItem>
          <FormItem
            v-if="showPartition"
            class="option-item-name"
            label="分区字段"
            :rules="{
              maxLength: 45
            }"
          >
            <Table checkType="none" :data="tableDetail.PartitionColumns">
              <TableColumn title="字段名" key="name">
                <template slot="template" slot-scope="data">
                  <div class="k-wrap">
                    <div class="k-input" style="width:100%">
                      <input
                        type="text"
                        v-model="data.PartitionName"
                        maxlength="25"
                        class=" k-inner"
                        v-if="isCreate"
                      />
                      <span v-else>{{ data.PartitionName }}</span>
                    </div>
                  </div>
                </template>
              </TableColumn>
              <TableColumn title="类型" key="PartitionType"></TableColumn>
            </Table>
            <div class="c-center" style="margin: 10px 0" v-if="isCreate">
              <a
                ><Button
                  @click="addPartitionRow"
                  type="secondary"
                  size="small"
                  :disabled="!canAddRow"
                  >增加一行</Button
                ></a
              >
            </div>
          </FormItem>
          <FormItem label="定时同步" v-if="showPartition">
            <div class="k-wrapper k-text" style="width:100%" v-if="!isRead">
              <Radio name="radio" trueValue="1" v-model="tableDetail.TimingSync"
                >是</Radio
              >
              <Radio name="radio" trueValue="0" v-model="tableDetail.TimingSync"
                >否</Radio
              >
            </div>
            <div v-else>
              {{ tableDetail.TimingSync === "1" ? "是" : "否" }}
            </div>
          </FormItem>
          <FormItem
            v-if="showTimingSyncInfo"
            class="option-item-name"
            label="日期格式"
            model="tableDetail.DateFormat"
            :isDirty="isDateDirty"
            :force="true"
            :rules="{
              maxLength: 45,
              withPartitions
            }"
          >
            <Input v-if="!isRead" v-model="tableDetail.DateFormat" />
            <span v-else>{{ tableDetail.DateFormat }}</span>
            <template slot="append">
              <Tooltip
                theme="light"
                canHover
                :content="
                  `y或Y 代表年，M 代表月份，d或D代表天，H 代表小时，m 代表分钟`
                "
              >
                <Icon class="ion-ios-help-outline"></Icon>
              </Tooltip>
              <div style="display:inline-block;padding-left:0.625rem">
                示例: {{ new Date() | datefmt(tableDetail.DateFormat) }}
              </div>
            </template>
          </FormItem>
          <FormItem label="时间粒度" v-if="showTimingSyncInfo">
            <ButtonGroup
              checkType="radio"
              v-model="tableDetail.Granularity"
              v-if="!isRead"
            >
              <!-- <Button value="beijing">1分钟</Button> -->
              <Button value="m5">5分钟</Button>
              <Button value="1h">1小时</Button>
              <Button value="1d">1天</Button>
            </ButtonGroup>
            <span v-else>{{
              { m5: "5分钟", "1h": "1小时", "1d": "1天" }[
                tableDetail.Granularity
              ]
            }}</span>
          </FormItem>
          <!-- <FormItem label="源数据路径" v-if="isCreate">
            <div class="k-wrapper" style="width:100%">
              <PathSelect
                style="    width: 300px;"
                :loading="pathLoading"
                @path-selected="selectBucketPath"
                :tree="bucketPathList"
              ></PathSelect>
            </div>
          </FormItem> -->
          <!-- <FormItem label="源数据路径" v-if="isCreate">
            <div class="k-wrapper" style="width:100%">
              <PathSelectTree
                style="    width: 300px;"
                :loading="pathLoading"
                @path-selected="selectBucketPath"
                :tree="bucketPathList"
              ></PathSelectTree>
            </div>
          </FormItem> -->
          <!-- <FormItem
          label="源数据路径"
          v-if="isCreate"
          model="tableDetail.Path"
          :rules="{
            required: true,
            isExist: validatePath
          }"
        >
          <Input v-model="tableDetail.Path"></Input>
        </FormItem> -->
          <FormItem
            label="数据格式"
            model="tableDetail.DataType"
            :rules="{
              required: true
            }"
          >
            <span v-if="action === 'read' || action === 'edit'">{{
              tableDetail.DataType
            }}</span>
            <ButtonGroup
              checkType="radio"
              v-model="tableDetail.DataType"
              v-if="isCreate"
            >
              <Button value="TEXTFILE">TXT</Button>
              <Button value="ORC">ORC</Button>
              <Button value="JSON">JSON</Button>
              <Button value="PARQUET">PARQUET</Button>
              <Button value="GZIP">GZ</Button>
            </ButtonGroup>
          </FormItem>
          <FormItem
            label="表字段分隔符"
            v-show="
              (tableDetail.DataType === 'TEXTFILE' ||
                tableDetail.DataType === 'GZIP') &&
                isCreate
            "
          >
            <span v-show="action === 'read' || action === 'edit'">{{
              tableDetail.Separation
            }}</span>
            <ButtonGroup checkType="radio" v-model="tableDetail.Separation">
              <Button value=",">逗号(,)</Button>
              <Button value="\t">制表符(\t)</Button>
              <Button value=" ">空格()</Button>
              <Button value="custom">自定义</Button>
            </ButtonGroup>
          </FormItem>
          <FormItem
            label="自定义分隔符"
            v-if="
              (tableDetail.DataType === 'TEXTFILE' ||
                tableDetail.DataType === 'GZIP') &&
                tableDetail.Separation === 'custom'
            "
          >
            <!-- <Input v-model="tableDetail.splitCustom" placeholder="自定义分隔符" /> -->
            <div class="k-wrap">
              <div class="k-input" style="width:100%">
                <input
                  type="text"
                  v-model="tableDetail.splitCustom"
                  placeholder="自定义分隔符"
                  maxlength="15"
                  class=" k-inner"
                />
              </div>
            </div>
          </FormItem>
        </template>
        <template v-if="dbtype.type === 'rds'">
          <FormItem label="RDS实例">
            <span>{{ tableDetail.InstanceName }} </span>
          </FormItem>
          <FormItem label="RDS实例ID">
            <span>{{ tableDetail.InstanceId }} </span>
          </FormItem>
          <FormItem label="RDS数据库">
            <span>{{ tableDetail.DatabaseName }} </span>
          </FormItem>
        </template>

        <FormItem label="跳过行数" v-if="isCreate">
          <!-- <div class="k-wrap" style="width:100%" v-if="isCreate">
            <div class="k-input" style="width:100%">
              <input
                type="text"
                
                maxlength="500"
                class=" k-inner"
              />
            </div>
            <Spinner :max="5" :min="-5" vertical />
          </div> -->
          <Spinner
            :min="0"
            :step="1"
            :precision="0"
            v-model="tableDetail.SkipHeaderLines"
            vertical
          />
          <template slot="append">
            <Tooltip
              theme="light"
              canHover
              content="每个文件读取时，跳过行数开始读取"
            >
              <Icon class="ion-ios-help-outline"></Icon>
            </Tooltip>
          </template>
        </FormItem>
        <FormItem label="字段列表">
          <Button
            class="c-mgr-10"
            type="secondary"
            size="small"
            v-if="isCreate"
            @click="autoFill(tableDetail)"
            >自动识别</Button
          >
          <Button
            type="secondary"
            size="small"
            @click="delBatch"
            v-if="action !== 'read'"
            :disabled="canDelBatch"
            >批量删除</Button
          >
        </FormItem>
        <FormItem>
          <Table
            ref="actiontable"
            :data="tableDetail.Columns"
            :checkType="action === 'read' ? 'none' : 'checkbox'"
            :rowCheckable="false"
            :rowClassName="rowClass"
            :loading="loading"
            v-show="showTable"
            @$change:checked="checkedAction"
          >
            <TableColumn key="tableDetail.Columns.ColumnName" title="字段名">
              <template slot-scope="item">
                <!-- 查看表字段 -->
                <span v-if="action === 'read'">{{ item.ColumnName }}</span>
                <!-- 编辑表，已有字段不能编辑 -->
                <span v-if="action === 'edit' && !item.isAdded">{{
                  item.ColumnName
                }}</span>
                <!-- 创建表，添加新字段 -->
                <div
                  class="k-wrap"
                  v-if="isCreate || (action === 'edit' && item.isAdded)"
                >
                  <div
                    class="k-input"
                    :class="{
                      'k-disabled': action === 'edit' && !item.isAdded
                    }"
                    style="width:100%"
                  >
                    <input
                      type="text"
                      v-model="item.ColumnName"
                      maxlength="25"
                      class=" k-inner"
                      :disabled="action === 'edit' && !item.isAdded"
                    />
                  </div>
                </div>
              </template>
            </TableColumn>
            <TableColumn
              key="tableDetail.Columns.ColumnType"
              title="类型"
              minWidth="120"
            >
              <template slot-scope="item">
                <!-- 查看表字段 -->
                <span v-if="action === 'read'">{{
                  item.ColumnType.toLowerCase()
                }}</span>
                <!-- 编辑表，已有字段不能编辑 -->
                <span v-if="action === 'edit' && !item.isAdded">{{
                  item.ColumnType.toLowerCase()
                }}</span>
                <!-- 创建表，添加新字段 -->
                <div v-if="isCreate || (action === 'edit' && item.isAdded)">
                  <Select
                    :allowUnmatch="true"
                    v-model="item.ColumnType"
                    :value="item.ColumnType || 'STRING'"
                    style="width:100%"
                  >
                    <Option v-for="type in dataType" :key="type" :value="type">
                      {{ type.toLowerCase() }}
                    </Option>
                  </Select>
                </div>
              </template>
            </TableColumn>
            <TableColumn
              key="tableDetail.Columns.ColumnComment"
              title="描述"
              v-if="dbtype.type === 'ks3'"
            >
              <template slot-scope="item">
                <!-- 查看表字段 -->
                <span v-if="action === 'read'">{{ item.ColumnComment }}</span>
                <!-- 编辑表，已有字段不能编辑 -->
                <span v-if="action === 'edit' && !item.isAdded">{{
                  item.ColumnComment
                }}</span>
                <!-- 创建表，添加新字段 -->
                <div
                  class="k-wrap"
                  style="width:100%"
                  v-if="isCreate || (action === 'edit' && item.isAdded)"
                >
                  <div
                    class="k-input"
                    :class="{
                      'k-disabled': action === 'edit' && !item.isAdded
                    }"
                    style="width:100%"
                  >
                    <input
                      type="text"
                      v-model="item.ColumnComment"
                      maxlength="500"
                      class=" k-inner"
                      :disabled="action === 'edit' && !item.isAdded"
                    />
                  </div>
                </div>
              </template>
            </TableColumn>
            <TableColumn
              key="tableDetail.Columns.data"
              title="示例"
              v-if="dbtype.type === 'ks3' && isCreate"
            >
              <span slot-scope="item">{{ item.data }}</span>
              <!-- <Input slot-scope="item" v-model="item.demo" style="width:100%" v-else/> -->
            </TableColumn>
            <TableColumn title="操作" key="op" ignore v-if="action !== 'read'">
              <template slot="template" slot-scope="item">
                <!-- <Button v-if="!item.isDel" @click="delRow(item)" class="c-mgr-10" type="secondary" size="small">删除</Button> -->
                <a v-if="!item.isDel" class="c-mgr-10"
                  ><span @click="delRow(item)">删除</span></a
                >
                <!-- <Button v-if="item.isDel" @click="unDel(item)" type="secondary" size="small">删除</Button> -->

                <a
                  ><span v-if="item.isDel" @click="unDel(item)"
                    >撤销删除</span
                  ></a
                >
              </template>
            </TableColumn>
          </Table>
          <div class="c-center" style="margin: 10px 0" v-if="action !== 'read'">
            <a
              ><Button @click="addRow" type="secondary" size="small"
                >增加一行</Button
              ></a
            >
          </div>
        </FormItem>
        <FormItem>
          <Button
            class="c-mgr-20"
            type="primary"
            v-if="action !== 'read'"
            :loading="loading"
            @click="submit"
            >确认</Button
          >
          <Button @click="cancel">取消</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import { Form, FormItem } from 'kpc/components/form';
import { Table, TableColumn } from 'kpc/components/table';
import { Tooltip } from 'kpc/components/tooltip';
import { Input } from 'kpc/components/input';
import Dialog from 'kpc/components/dialog';
import { Select, Option } from 'kpc/components/select';
import Spinner from 'kpc/components/spinner';
import { Radio } from 'kpc/components/radio';
// import Checkbox from 'kpc/components/checkbox';
import { Button, ButtonGroup } from 'kpc/components/button';
import { requestCheckLocation, requestBucketPathList } from '@/apis/meta-data';
import Icon from 'kpc/components/icon';
import PathSelect from '@/components/path-select.vue';
// import PathSelectTree from '@/components/path-select-tree.vue';
const nameReg = /^[a-zA-Z][_a-zA-Z0-9]*$/;
const descReg = new RegExp('[`~@#$^&|\\<>/~@#￥&]');
// const deepCopy = obj => JSON.parse(JSON.stringify(obj))
export default {
  props: {
    tableDetail: {
      type: Object,
      default: function() {
        return {};
      }
    },
    action: {
      type: String,
      default: 'read'
    },
    dbtype: {
      type: Object,
      default: function() {
        return {};
      }
    },
    dataType: {
      type: Array,
      default: function() {
        return [];
      }
    },
    bucketList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    tableListHeight: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      // loading: false,
      existNameMap: {},
      showTable: true,
      colomns: [],
      pathLoading: false,
      bucketPathList: [],
      canDelBatch: true,
      isShowDir: false,
      isDateDirty: false,
      gMsg: ''
    };
  },
  computed: {
    nativeProps() {
      return {};
    },
    isCreate() {
      return this.action === 'create';
    },
    isRead() {
      return this.action === 'read';
    },
    showPartition() {
      console.log(
        this.tableDetail.IsPartition - 0 && this.isCreate,
        this.isCreate,
        this.tableDetail.IsPartition - 0
      );
      return this.tableDetail.IsPartition - 0;
    },
    showTimingSyncInfo() {
      console.log(
        this.tableDetail.TimingSync - 0 && this.tableDetail.IsPartition - 0,
        111
      );
      return this.showPartition && this.tableDetail.TimingSync - 0;
    },
    canAddRow() {
      return this.tableDetail.PartitionColumns.length < 3;
    },
    formBoxHeight() {
      let diff = 320;
      if (this.isCreate) {
        diff += 50;
      }
      if (this.dbtype.type !== 'ks3') {
        diff += 50;
      }
      return this.tableListHeight + diff;
    },
    tabFixHeight() {
      let diff = 0;
      let addColHeight = 40;
      let formItemHeight = 60;
      let createFormHeight = 50;
      if (this.action === 'edit' || this.isCreate) {
        diff = addColHeight;
      }
      if (this.isCreate) {
        diff += createFormHeight;
      }
      if (this.tableDetail.Separation === 'custom') {
        diff += formItemHeight;
      }
      return this.tableListHeight - diff;
    },
    partitionRowLen() {
      let partitionRowLen = 0;
      Array.isArray(this.tableDetail.PartitionColumns)
        ? this.tableDetail.PartitionColumns.forEach(item => {
            item.PartitionName ? partitionRowLen++ : '';
          })
        : '';
      return partitionRowLen;
    }
  },
  watch: {
    'tableDetail.Bucket'(n, o) {
      console.log('tableDetail.Bucket changed');
      if (n !== o && n) {
        this.tableDetail.Path = '';
        this.tableDetail.bucketPathList = [];
        this.getBucketPath();
      }
    },
    partitionRowLen() {
      this.isDateDirty = true;
    }
  },
  methods: {
    withPartitions(value) {
      let partitionRowLen = this.partitionRowLen;
      let valueLen = value.trim().split(' ').length;
      console.log(
        'valueLen , partitionRowLen , valueLen === partitionRowLen',
        valueLen,
        partitionRowLen,
        valueLen === partitionRowLen
      );
      if (valueLen && partitionRowLen && valueLen === partitionRowLen) {
        this.gMsg = '';
      } else {
        this.gMsg = '日期格式需要与分区字段数相匹配';
      }
      return (
        (valueLen && partitionRowLen && valueLen === partitionRowLen) ||
        '日期格式需要与分区字段数相匹配'
      );
    },
    checkPartitionRow() {
      console.log(this.tableDetail.PartitionColumns);
      let hasError = false;
      let hasPartitionRow = false;
      let names = [];
      for (let i = 0; i < this.tableDetail.PartitionColumns.length; i++) {
        let item = this.tableDetail.PartitionColumns[i];
        if (item.PartitionName) {
          hasPartitionRow = true;
          names.push(item.PartitionName);
          if (!nameReg.test(item.PartitionName)) {
            this.Message.error(
              '日期字段，字段名只能包含字母数字和下划线，只能以字母开头'
            );
            hasError = true;
            break;
          }
        }
      }
      for (let i = 0; i < this.tableDetail.Columns.length; i++) {
        let ele = this.tableDetail.Columns[i];
        if (names.indexOf(ele.ColumnName) > -1) {
          this.Message.error(
            `日期字段，字段名 ${ele.ColumnName} 不能和字段列表字段名重复；`
          );
          hasError = true;
          break;
        }
      }
      if (!hasPartitionRow) {
        this.Message.error('日期字段，至少需要一个字段名');

        hasError = true;
      }
      return hasError;
    },
    showDir() {
      if (!this.tableDetail.Bucket) {
        this.Message.error('请先选择bucket');
        return;
      }
      this.isShowDir = true;
    },
    checkedAction(instance, newValue) {
      console.log(instance, newValue);
      if (newValue.length > 1) {
        this.canDelBatch = false;
      } else {
        this.canDelBatch = true;
      }
    },
    selectBucketPath(key) {
      this.tableDetail.Path = key;
    },
    async getBucketPath() {
      this.pathLoading = true;
      try {
        let res = await requestBucketPathList({
          Bucket: this.tableDetail.Bucket
        });
        console.log(res);
        this.bucketPathList = res.data.Data;
      } catch (error) {
        this.bucketPathList = [];
        this.Message.error(`获取源数据路径失败：${error.msg}`);
      }
      this.pathLoading = false;
    },
    updateTable() {
      this.showTable = false;
      this.$nextTick(() => {
        this.showTable = true;
      });
    },
    async validatePath(value) {
      return new Promise((resolve, reject) => {
        if (!this.tableDetail.Bucket) {
          reject({ message: '请先选择bucket' });
        }
        this.showLoading();
        requestCheckLocation({
          Path: value,
          Bucket: this.tableDetail.Bucket
        }).then(
          res => {
            console.log(res);
            this.hideLoading();
            resolve(true);
          },
          err => {
            this.hideLoading();
            reject({ message: `${err.msg}` });
          }
        );
      });
    },
    checkColumn() {
      let columns = this.tableDetail.Columns;
      let msg = '';
      let nameList = [];
      let invalidName = [];
      let repeatName = [];
      let commentsList = [];
      let delLength = 0;
      for (let i = 0; i < columns.length; i++) {
        let column = columns[i];
        // 清空错误信息
        column.msg = '';
        let newName = column.ColumnName;
        if (column.isDel) {
          delLength++;
          continue;
        }
        if (!nameReg.test(newName)) {
          invalidName.push(newName);
        }
        if (!nameList.includes(newName)) {
          nameList.push(newName);
        } else {
          !repeatName.includes(newName) ? repeatName.push(newName) : '';
        }
        if (descReg.test(column.ColumnComment)) {
          commentsList.push(column.ColumnComment);
        }
      }
      if (invalidName.length) {
        msg = `字段名只能包含字母数字和下划线，只能以字母开头 ${invalidName.join(
          ','
        )} ; `;
      }
      if (repeatName.length) {
        msg += `字段名重复 ${repeatName.join(',')} ;`;
      }
      if (commentsList.length) {
        msg += '字段描述不能有特殊符号';
      }
      if (delLength === columns.length) {
        msg = '字段列表不能全部删除;';
      }

      console.log(delLength === columns.length);
      return msg;
    },
    delBatch() {
      let checkedData = this.$refs.actiontable.getCheckedData();
      this.$emit('del-batch', checkedData);
      this.$nextTick(() => {
        this.updateTable();
      });
    },
    rowClass(value) {
      // this.loading = true
      if (value.isDel) {
        return 'del-row';
      }
      // this.loading = false
    },
    del() {
      this.$emit('del-clicked');
    },
    query() {
      this.$emit('query-clicked');
    },
    edit() {
      this.$emit('edit-clicked');
    },
    create() {
      this.$emit('create-clicked');
    },
    submit() {
      // if (!this.tableDetail.Columns[0].ColumnName) {
      //   this.Message.error('字段列表 字段名不能为空');
      //   return;
      // }
      let res = this.checkColumn();
      if (res) {
        this.Message.error(res);
        return;
      }
      if (this.tableDetail.IsPartition - 0) {
        let resCheckPartitionRow = this.checkPartitionRow();
        if (resCheckPartitionRow) {
          return;
        }
      }
      if (this.gMsg) {
        this.Message.error(this.gMsg);
        return;
      }
      this.$emit('submit', this.tableDetail);
    },
    addRow() {
      this.$emit('add-row');
      this.$nextTick(() => {
        this.updateTable();
      });
    },
    addPartitionRow() {
      if (!this.canAddRow) {
        return;
      }
      this.tableDetail.PartitionColumns.push({
        PartitionName: '',
        PartitionType: 'STRING'
      });
    },
    delRow(data) {
      this.$emit('del-row', data);
    },
    unDel(data) {
      this.$emit('undel-row', data);
    },
    autoFill(data) {
      if (!data.Path) {
        this.Message.error('请输入源数据路径');
        return;
      }
      if (!data.Bucket) {
        this.Message.error('请选择bucket');
        return;
      }
      if (!data.DataType) {
        this.Message.error('请选择数据类型');
        return;
      }
      if (data.DataType === 'TEXTFILE' && !data.Separation) {
        this.Message.error('请选择分隔符');
        return;
      }
      this.$emit('autofill-clicked', data);
    },
    cancel() {
      this.$emit('cancel-clicked');
    }
  },
  components: {
    Form,
    FormItem,
    Button,
    ButtonGroup,
    Select,
    Option,
    Input,
    Table,
    TableColumn,
    Dialog,
    PathSelect,
    Radio,
    Tooltip,
    Icon,
    Spinner
    // PathSelectTree
    // Checkbox
  }
};
</script>
<style lang="stylus" scoped>
.del-row {
  background: #e5e5e5;
}

.k-form-item .k-label {
  color: #666;
  font-size: 14px;
  display: inline-block;
  // width: 100px
  // text-align: right
  font-weight: normal;
  margin: 0;
  // padding-top: 11px
  // margin-right 20px
}
.k-text {
  margin-right: 0.5em;
  color: #666;
  font-size: 14px;
}
.k-body .k-form-item > .k-content {
  width: 100%
}
</style>
